const FooterContent = null;

export default FooterContent;
